// Work Orders list filtering and sorting: the chips (All, High Priority, Ready to Bill, Awaiting
// Assignment, Closed), the Filter & sort panel (checkboxes, dates, badge, Clear), Sort by, the
// Operations view's quick filters, and the drag-to-reorder Sort helper.
// Split out of app.js (docs/split-plan.md, session 4). The app.js helpers it calls come in through
// setWoFilterDeps() (see estimates.js for why it doesn't import app.js back); the *Active flags are
// only read there.
import { watchNoMatch } from './uiStates';
import { getDB } from './utilities';
import { compareUrgency, earliestOverdueEta, isThisWeek, resolveAttentionSlot, splitTechs } from './wo-ops-aggregation';

let shell = null;
export function setWoFilterDeps(deps) { shell = deps; }

export let Sort = function (target_id) {
  let _mobile = mobileCheck();
  let wrap;
  let list;
  let draggable;
  let dragging;
  let drIdx;
  let tarIdx;
  let moveable = false;
  let listname = "list";
  let dr_listname = "draggable";
  let _scroll = document.body;

  var handle = {
    up: (_mobile) ? "touchend" : "mouseup",
    move: (_mobile) ? "touchmove" : "mousemove",
    down: (_mobile) ? "touchstart" : "mousedown"
  };

  this.setScroll = function (obj) {
    _scroll = obj;
  }

  this.setListname = function (str) {
    listname = str;
  }

  this.setdrListname = function (str) {
    dr_listname = str;
  }

  function set_e() {
    wrap = document.getElementById(target_id);
    if (!wrap) {
      console.error(`Element with id "${target_id}" not found`);
      return;
    }
    list = wrap.getElementsByClassName(listname);
    draggable = wrap.getElementsByClassName(dr_listname);
    _mobile = mobileCheck();
    drIdx = null;

    wrap.setAttribute("sorting", "false");

    for (var i = 0; i < draggable.length; i++) {
      (function (i) {
        list[i].setAttribute("dragging", "false");
        list[i].setAttribute("drag_after", "false");
        draggable[i].addEventListener(handle.down, function (e) {
          // ... (rest of the event listener code)
        });
      })(i);
    }
  }


  function init() {
    if (document.getElementById(target_id)) {
      set_e();
      moveable = true;
    } else {
      console.error(`Element with id "${target_id}" not found. Sort initialization failed.`);
    }
  }
  this.init = init;

  function set_y(elem, y) {
    elem.style.transform = "translate3d(0, " + y + "px, 0)";
    elem.style.webkitTransform = "translate3d(0, " + y + "px, 0)";
  }

  function remove_y(elem) {
    elem.style.transform = "";
    elem.style.webkitTransform = "";
  }

  function mobileCheck() {
    var check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
}

// The Filter button previously always reverted to plain "Filter" once the panel closed
// (closeOpenViews() resets its inline styles), with no indication any filters were active —
// checked boxes, a date range, or a Billing Status selection all left zero trace on the button
// itself. Recomputed wherever a filter control actually changes (checkboxes/dates via
// applyFilters(), Billing Status buttons, and clearFilters()).
function updateFilterButtonBadge() {
  const btn = document.getElementById('filter-view-button');
  if (!btn) return;
  const checkedCount = document.querySelectorAll('#filter-view input[type="checkbox"]:checked').length;
  // Assignment's "Any" radio has value="" and never counts as active.
  const radioCount = document.querySelectorAll('#filter-view input[type="radio"]:checked').length
    - document.querySelectorAll('#filter-view input[type="radio"]:checked[value=""]').length;
  const dateCount = (document.getElementById('start-date').value ? 1 : 0) + (document.getElementById('end-date').value ? 1 : 0);
  const billingActive = (billingWorkOrdersActive || closedWorkOrdersActive || billingJobsActive || closedJobsActive) ? 1 : 0;
  const total = checkedCount + radioCount + dateCount + billingActive;
  // (currentSortType is declared further down this file; this can run before it is.)
  let sorted = '';
  try { if (currentSortType !== 'Start Date' || !isAscending) sorted = ` · ${currentSortType} ${isAscending ? '▲' : '▼'}`; } catch { /* not yet */ }
  btn.textContent = `Filter & sort${total > 0 ? ` (${total})` : ''}${sorted}`;
  try { btn.title = `Sorted by ${currentSortType} ${isAscending ? '▲' : '▼'}`; } catch { /* not yet */ }
  updateFilterSectionCounts();
}

// Each collapsible filter section shows a live "(N)" summary when collapsed — reuses the same
// counting approach as the button badge above, generically (works for checkbox/radio groups and
// the Billing Status chip row without needing per-section special-casing).
function updateFilterSectionCounts() {
  document.querySelectorAll('#filter-view .filter-section').forEach(section => {
    const countEl = section.querySelector('.filter-section-count');
    if (!countEl) return;
    const checkedInputs = [...section.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')].filter(el => el.value);
    const activeChips = section.querySelectorAll('.filter-chip-btn.active').length;
    const n = checkedInputs.length + activeChips;
    countEl.textContent = n > 0 ? `(${n})` : '';
  });
}

function setupFilterAccordion() {
  document.querySelectorAll('#filter-view .filter-section-header').forEach(header => {
    header.addEventListener('click', () => {
      header.closest('.filter-section').classList.toggle('expanded');
    });
  });
}

function setupFilterListeners() {
  const filterView = document.getElementById('filter-view');
  // Assignment is a radio group now (was checkboxes) — needs the same change listener.
  const checkboxes = filterView.querySelectorAll('input[type="checkbox"], input[type="radio"]');

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', applyFilters);
  });
}


let selectedFilterButtons;

document.getElementById('start-date').addEventListener('change', () => applyFilters(false));
document.getElementById('end-date').addEventListener('change', () => applyFilters(false));

export async function applyFilters(shouldUpdate = true) {
  updateFilterButtonBadge();
  try {
    const filterView = document.getElementById('filter-view');
    const checkboxes = filterView.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
    const startDateInput = document.getElementById('start-date').value;
    const endDateInput = document.getElementById('end-date').value;

    let items = document.querySelectorAll('#table-content .table-item');
    let currentView = 'work-order-view';

    if (document.getElementById('job-view').style.display === 'flex') {
      currentView = 'job-view';
      items = document.querySelectorAll('#jobList .job-item');
    }

    // Reset all items to hidden by default
    items.forEach(item => {
      item.classList.add('filtered');
      item.style.display = 'none';
    });

    // Status and the old separate "Shrinkwrap Status" group both filter the same underlying
    // data.Status field — they were independent AND'd groups before, so checking one box in each
    // always matched nothing. Shrinkwrap-stage checkboxes now carry data-filter-group="Status" too
    // (see index.html), merging them into one OR'd group.
    const selectedFilters = {
      'WO Category': [],
      'Priority': [],
      'Status': [],
      'Op Type': [],
      'Assignment': [],
    };

    // The "Any" Assignment radio has value="" and is skipped (empty value = no filter on that
    // group) — data-filter-group replaces the old fragile checkbox.closest('ul').closest('li')...
    // DOM-walk, which broke once the panel was restructured into collapsible sections.
    checkboxes.forEach(control => {
      if (!control.value) return;
      const filterType = control.dataset.filterGroup;
      if (filterType && selectedFilters[filterType]) selectedFilters[filterType].push(control.value);
    });

    const startDate = startDateInput ? new Date(startDateInput) : null;
    const endDate = endDateInput ? new Date(endDateInput) : null;

    function filterItem(info) {
      // One row with unreadable data must not abort the whole filter pass (it used to
      // throw here and leave every later row unfiltered) — show it and say which.
      let data;
      try { data = JSON.parse(info.getAttribute('data-jobinfo')); } catch (_) { data = null; }
      if (!data || typeof data !== 'object') {
        console.warn('applyFilters: row without readable data-jobinfo', info.dataset.workorder || info.dataset.id || info.className);
        info.classList.remove('filtered');
        info.style.display = '';
        return;
      }
      const hauled = info.getAttribute('data-hauled') ? true : false;
      let opTypeList = [];
      try { opTypeList = JSON.parse(info.getAttribute('data-optypes') || '[]') || []; } catch (_) { opTypeList = []; }
    
      if (data.Status === 'Complete') {
        data.Status = 'Ready to Bill';
      }
    
      let shouldShow = true;
    
      for (const [filterType, filterValues] of Object.entries(selectedFilters)) {
        if (filterValues.length > 0) {
          switch (filterType) {
            case 'WO Category':
              if (!filterValues.includes(data.Category)) shouldShow = false;
              break;
            case 'Priority':
              if (!filterValues.includes(data.Priority)) shouldShow = false;
              break;
            case 'Status':
              if (!filterValues.includes(data.Status)) {
                shouldShow = false;
              }
              if (filterValues.includes('Hauled') && hauled === 'false') {
                shouldShow = false;
              }
              break;
            case 'Op Type':
              if (currentView === 'work-order-view') {
                if (!opTypeList.some(opType => filterValues.includes(opType))) shouldShow = false;
              } else {
                if (!filterValues.includes(data.Op_Type)) shouldShow = false;
              }
              break;
            case 'Assignment':
              if (filterValues.includes('Assigned') && (!data.Techs || data.Techs === '')) {
                shouldShow = false;
              }
              if (filterValues.includes('Awaiting Assignment') && (data.Techs && data.Techs !== '')) {
                shouldShow = false;
              }
              break;
          }
        }
        if (!shouldShow) break;
      }
    
      // Apply date filtering
      if (shouldShow && (startDate || endDate)) {
        const jobStartDate = data.Start_Date ? new Date(data.Start_Date) : new Date(data.Request_Date);
        if (isNaN(jobStartDate)) shouldShow = false;
        if (startDate && jobStartDate < startDate) shouldShow = false;
        if (endDate && jobStartDate > endDate) shouldShow = false;
      }
    
      // Set visibility based on filter results. '' not 'flex' — see
      // updateTable()/searchJobs() for why.
      if (shouldShow) {
        info.classList.remove('filtered');
        info.style.display = '';
      } else {
        info.classList.add('filtered');
        info.style.display = 'none';
      }
    }
    

    // Apply filters to all items
    items.forEach(filterItem);

    if (shouldUpdate) {
      updateTable();
    }

  } catch (error) {
    console.error('Error in applyFilters:', error);
  }
}

function toggleWorkOrders(filter) {
  const workOrders = document.querySelectorAll('.table-item');
  workOrders.forEach(wo => {
    if (wo.classList.contains(filter)) {
      wo.style.display = 'flex';
    } else {
      wo.style.display = 'none';
    }
  });

}

function toggleJobs(filter) {
  // The stylesheet hides Ready to Bill / Closed ops everywhere else; this lets the chosen ones show.
  const jobList = document.getElementById('jobList');
  jobList?.classList.toggle('show-complete', filter === 'complete-job');
  jobList?.classList.toggle('show-closed', filter === 'closed-job');

  const jobs = document.querySelectorAll('.job-item');
  jobs.forEach(job => {
    if (job.classList.contains(filter)) {
      // '' not 'flex' — see updateTable()/searchJobs() for why.
      job.style.display = '';
    } else {
      job.style.display = 'none';
    }
  });

}

export let billingJobsActive = false;
export let closedJobsActive = false;
export let billingWorkOrdersActive = false;
export let closedWorkOrdersActive = false;

document.getElementById('filter-complete').addEventListener('click', () => {
  const workOrderView = document.getElementById('work-order-view');
  const displayStyle = window.getComputedStyle(workOrderView).display;

  if (displayStyle === 'flex') {
    toggleWorkOrders('complete-job');
    billingWorkOrdersActive = true;
    closedWorkOrdersActive = false;
  } else {
    toggleJobs('complete-job');
    billingJobsActive = true;
    closedJobsActive = false;
  }
  document.getElementById('filter-complete').classList.add('active');
  document.getElementById('filter-closed').classList.remove('active');
  updateFilterButtonBadge();
});

document.getElementById('filter-closed').addEventListener('click', () => {
  const workOrderView = document.getElementById('work-order-view');
  const displayStyle = window.getComputedStyle(workOrderView).display;

  if (displayStyle === 'flex') {
    toggleWorkOrders('closed-job');
    billingWorkOrdersActive = false;
    closedWorkOrdersActive = true;
  } else {
    toggleJobs('closed-job');
    billingJobsActive = false;
    closedJobsActive = true;
  }
  document.getElementById('filter-closed').classList.add('active');
  document.getElementById('filter-complete').classList.remove('active');
  updateFilterButtonBadge();
});

function setupSortListeners() {
  const sortView = document.getElementById('sort-view');
  const sortOptions = sortView.querySelectorAll('li');

  sortOptions.forEach(option => {
    // Remove any existing listeners before adding a new one
    option.removeEventListener('click', applySorting);
    option.addEventListener('click', applySorting);
  });
}

let currentSortType = 'Start Date';
let isAscending = true;

// The active sort field + direction previously only showed inside the (usually-closed) Sort
// dropdown, via .active-sort/.sort-asc/.sort-desc on the matching <li> — the button itself always
// reverted to plain "Sort" once closed, so there was no way to tell what governed the list's
// current order without reopening the menu.
// Sort lives in the Filter & sort panel now: its section header names the order, and the button
// does too whenever it isn't the default (Start Date ▲).
function updateSortButtonLabel() {
  const cur = document.getElementById('sort-current');
  if (cur) cur.textContent = `${currentSortType} ${isAscending ? '▲' : '▼'}`;
  document.querySelectorAll('#sort-view li').forEach(li => {
    li.classList.toggle('active-sort', li.textContent.trim() === currentSortType);
    li.classList.toggle('sort-asc', li.textContent.trim() === currentSortType && isAscending);
    li.classList.toggle('sort-desc', li.textContent.trim() === currentSortType && !isAscending);
  });
  updateFilterButtonBadge();
}

export function applySorting(e, sortType = null) {
  let targetElement;

  // Several call sites invoke this bare (applySorting(), no event) just to
  // re-apply the current sort after a data change — not to change what's
  // sorted by. Confirmed live: that crashed on `e.target` every time (e.g.
  // every inline Schedule_Date edit), silently aborting the rest of that
  // handler (searchCall/searchJobs/updateWeekView never ran). Only derive
  // sortType from the event when there is one.
  if (e && sortType === null) {
    sortType = e.target.textContent.trim();
    targetElement = e.target;

    if (sortType === currentSortType) {
      isAscending = !isAscending;
    } else {
      currentSortType = sortType;
      isAscending = true;
    }
  }

  performSort();

  const sortView = document.getElementById('sort-view');
  sortView.querySelectorAll('li').forEach(li => {
    li.classList.remove('active-sort', 'sort-asc', 'sort-desc');
  });

  if (targetElement) {
    targetElement.classList.add('active-sort', isAscending ? 'sort-asc' : 'sort-desc');
  }

  updateSortButtonLabel();

  updateTable(false);
}

function performSort() {
  const tableContent = document.getElementById('table-content');
  const jobList = document.getElementById('jobList');

  // Combine all items into one array for sorting
  const allItems = [
    ...Array.from(tableContent.querySelectorAll('.table-item')),
    ...Array.from(jobList.querySelectorAll('.job-item'))
  ];

  function sortItems(items) {
    return items.sort((a, b) => {
      const dataA = JSON.parse(a.getAttribute('data-jobInfo'));
      const dataB = JSON.parse(b.getAttribute('data-jobInfo'));
      let comparison = 0;

      switch (currentSortType) {
        case 'Haul Date':
        case 'Request Date':
        case 'Scheduled Date':
        case 'Start Date': {
          let aDate, bDate;
          if (currentSortType === 'Haul Date') {
            aDate = new Date(dataA.Haul_Date || 0);
            bDate = new Date(dataB.Haul_Date || 0);
          } else if (currentSortType === 'Request Date') {
            aDate = new Date(dataA.Request_Date || 0);
            bDate = new Date(dataB.Request_Date || 0);
          } else if (currentSortType === 'Scheduled Date') {
            aDate = new Date(dataA.Schedule_Date || 0);
            bDate = new Date(dataB.Schedule_Date || 0);
          } else {
            // Same fallback as the first render (createTable): no Start_Date → Request_Date,
            // so a re-sort keeps the order the page loaded with.
            aDate = new Date(dataA.Start_Date || dataA.Request_Date || 0);
            bDate = new Date(dataB.Start_Date || dataB.Request_Date || 0);
          }

          comparison = aDate - bDate;

          // If the dates are the same, sort by work order
          if (comparison === 0) {
            const aWorkOrder = dataA.Work_Order || '';
            const bWorkOrder = dataB.Work_Order || '';
            comparison = aWorkOrder.localeCompare(bWorkOrder);
          }
          break;
        }
        case 'Customer [Last Name]':
          comparison = (dataA.Customer_Name || '').localeCompare(dataB.Customer_Name || '');
          break;
        case 'Work Order #':
          comparison = (dataA.Work_Order || '').localeCompare(dataB.Work_Order || '');
          break;
        case 'Status':
          comparison = (dataA.Status || '').localeCompare(dataB.Status || '');
          break;
        case 'Boat':
          comparison = (dataA.Boat_Name || '').localeCompare(dataB.Boat_Name || '');
          break;
        case 'Tech':
          comparison = (dataA.Techs || '').localeCompare(dataB.Techs || '');
          break;
        case 'Op Code':
          comparison = String(dataA.OpCode ?? '').localeCompare(String(dataB.OpCode ?? ''), undefined, { numeric: true });
          break;
        case 'Urgency': {
          const aIsWO = a.classList.contains('table-item');
          const bIsWO = b.classList.contains('table-item');
          if (aIsWO && bIsWO) {
            const aOps = (shell.jobsByWorkOrder && shell.jobsByWorkOrder.get(dataA.Work_Order)) || [dataA];
            const bOps = (shell.jobsByWorkOrder && shell.jobsByWorkOrder.get(dataB.Work_Order)) || [dataB];
            const aSlot = resolveAttentionSlot({ ops: aOps, receivingData: shell.latestReceivingData, boatData: null, rollupStatus: dataA.Status });
            const bSlot = resolveAttentionSlot({ ops: bOps, receivingData: shell.latestReceivingData, boatData: null, rollupStatus: dataB.Status });
            comparison = compareUrgency(
              { slot: aSlot, data: dataA, earliestOverdueEta: earliestOverdueEta(aOps, shell.latestReceivingData) },
              { slot: bSlot, data: dataB, earliestOverdueEta: earliestOverdueEta(bOps, shell.latestReceivingData) }
            );
          } else {
            comparison = (new Date(dataA.Schedule_Date || 0)) - (new Date(dataB.Schedule_Date || 0));
          }
          break;
        }
        default:
          console.warn('Unknown sort type:', currentSortType);
          return 0;
      }

      return isAscending ? comparison : -comparison;
    });
  }

  // Apply sorting and keep both filtered and non-filtered items in place
  const sortedItems = sortItems(allItems);

  // Re-insert items into the correct containers while preserving filtered state
  sortedItems.forEach(item => {
    const parentContainer = item.closest('.table-item') ? tableContent : jobList;

    // Re-append the item to its respective container
    parentContainer.appendChild(item);
  });

  reattachOperationPanels(tableContent);
}

// The expanded-operations panel (.operation-container-row, built by
// displayOperations()) lives as a plain DOM sibling right after its
// .table-item, not as that row's child — the above appendChild loop only
// moves .table-item elements, so resorting (e.g. after addOperation()'s
// Firebase write triggers a realtime re-render) left any open panel behind
// as every row got moved out from under it, usually stranding it at the
// very top of the list, detached from the WO it belonged to. Re-home it
// after every sort pass.
function reattachOperationPanels(tableContent) {
  tableContent.querySelectorAll('.operation-container-row[data-workorder]').forEach(panel => {
    const wo = panel.getAttribute('data-workorder');
    const ownerRow = tableContent.querySelector(`.table-item[data-workorder="${CSS.escape(wo)}"]`);
    if (ownerRow && ownerRow.nextElementSibling !== panel) {
      ownerRow.insertAdjacentElement('afterend', panel);
    }
  });
}

export function updateTable(shouldApplySort = true) {
  // Get the different sections with items
  const tableItems = Array.from(document.querySelectorAll('#table-content .table-item'));
  const jobItems = Array.from(document.querySelectorAll('#jobList .job-item'));

  // Instead of removing and re-appending items, we will only handle their visibility and sorting
  const allItems = [...tableItems, ...jobItems];

  allItems.forEach(item => {
    if (!item.classList.contains('filtered')) {
      // '' not 'flex' — #jobList mixes plain-flex .job-item rows with the
      // grid-based .job-item.op-table-row rows; '' defers to each row's own
      // stylesheet display value instead of clobbering the grid ones.
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });

  if (shouldApplySort) {
    if (!currentSortType) {
      currentSortType = 'Start Date';
      isAscending = false;
    }
    performSort();
  }

  // Handle additional logic like search if necessary
  shell.searchCall();
  shell.searchJobs();
}

document.getElementById('clear-filters').addEventListener('click', clearFilters);

export async function clearFilters() {
  billingWorkOrdersActive = false;
  closedWorkOrdersActive = false;
  billingJobsActive = false;
  closedJobsActive = false;
  document.getElementById('jobList')?.classList.remove('show-complete', 'show-closed');

  try {
    const selectedFilters = document.querySelectorAll('#filter-view input[type="checkbox"]:checked');
    document.getElementById('start-date').value = '';
    document.getElementById('end-date').value = '';
    selectedFilters.forEach(filter => {
      filter.checked = false;
    });
    const anyRadio = document.querySelector('input[name="assignment-filter"][value=""]');
    if (anyRadio) anyRadio.checked = true;
    document.getElementById('filter-complete')?.classList.remove('active');
    document.getElementById('filter-closed')?.classList.remove('active');
    document.querySelectorAll('#filter-view .filter-section.expanded').forEach(section => section.classList.remove('expanded'));
    updateFilterButtonBadge();

    // Reset all items to visible before re-applying the filters. '' not
    // 'flex' — see updateTable()/searchJobs() for why.
    let items = document.querySelectorAll('#table-content .table-item, #jobList .job-item');
    items.forEach(item => {
      item.classList.remove('filtered');
      item.style.display = '';
    });

    await applyFilters();
    updateTable();
  } catch (error) {
    console.log('Error removing filters', error);
  }
}

// Visible quick-filter chips — surface the most-used filters from the
// existing #filter-view dropdown (and the #filter-complete/#filter-closed
// buttons) without duplicating any filtering logic: each chip just drives
// the real control it stands in for, then mirrors that control's resulting
// state back onto itself for the active-pill look.
document.addEventListener('DOMContentLoaded', () => {
  const chipBar = document.getElementById('wo-quick-filters');
  if (!chipBar) return;

  const chips = {
    all: chipBar.querySelector('[data-chip="all"]'),
    highPriority: chipBar.querySelector('[data-chip="high-priority"]'),
    readyToBill: chipBar.querySelector('[data-chip="ready-to-bill"]'),
    awaitingAssignment: chipBar.querySelector('[data-chip="awaiting-assignment"]'),
    closed: chipBar.querySelector('[data-chip="closed"]'),
  };

  function setActiveChip(chip) {
    Object.values(chips).forEach(c => c?.classList.toggle('active', c === chip));
  }

  chips.all?.addEventListener('click', () => {
    clearFilters();
    setActiveChip(chips.all);
  });

  chips.highPriority?.addEventListener('click', () => {
    const cb = document.getElementById('filter-high-priority');
    if (!cb) return;
    cb.checked = !cb.checked;
    cb.dispatchEvent(new Event('change'));
    setActiveChip(cb.checked ? chips.highPriority : chips.all);
  });

  chips.awaitingAssignment?.addEventListener('click', () => {
    // Assignment is a radio group now (Any/Assigned/Awaiting Assignment), not a lone checkbox —
    // naively flipping .checked on an already-checked radio would leave the whole group with
    // nothing selected instead of reverting to "Any".
    const cb = document.getElementById('filter-tech-not-assigned');
    const anyRadio = document.querySelector('input[name="assignment-filter"][value=""]');
    if (!cb) return;
    const turningOn = !cb.checked;
    const target = turningOn ? cb : anyRadio;
    if (target) {
      target.checked = true;
      target.dispatchEvent(new Event('change'));
    }
    setActiveChip(cb.checked ? chips.awaitingAssignment : chips.all);
  });

  chips.readyToBill?.addEventListener('click', () => {
    document.getElementById('filter-complete')?.click();
    setActiveChip((billingWorkOrdersActive || billingJobsActive) ? chips.readyToBill : chips.all);
  });

  chips.closed?.addEventListener('click', () => {
    document.getElementById('filter-closed')?.click();
    setActiveChip((closedWorkOrdersActive || closedJobsActive) ? chips.closed : chips.all);
  });
});

// Operations-tab quick filters (design_handoff_wo_ops_list §Behavior): All /
// Mine / Unscheduled / Blocked / This week, single-select like the Work
// Orders chips above, plus a separate "Hide completed" toggle (not part of
// the single-select group — it layers on top of whichever chip is active).
let currentJobQuickFilter = 'all';

async function applyJobQuickFilter(kind) {
  currentJobQuickFilter = kind;
  await clearFilters();

  const currentUserFirst = (localStorage.getItem('currentUserName') || '').split(' ')[0];
  document.querySelectorAll('#jobList .job-item').forEach(row => {
    let data;
    try { data = JSON.parse(row.getAttribute('data-jobInfo') || '{}'); } catch (_) { data = {}; }
    let matches = true;
    if (kind === 'mine') {
      matches = currentUserFirst ? splitTechs(data.Techs).includes(currentUserFirst) : false;
    } else if (kind === 'unscheduled') {
      matches = !data.Schedule_Date || !data.Techs;
    } else if (kind === 'blocked') {
      matches = data.Status === 'Hold' || data.Parts_Ordered === 'Part Ordered' || Number(data.Operation_Dependency) > 0;
    } else if (kind === 'this-week') {
      matches = isThisWeek(data.Schedule_Date);
    }
    if (!matches) row.classList.add('filtered');
  });

  updateTable();
  updateJobQuickFilterCounts();
}

export function updateJobQuickFilterCounts() {
  // Ready to Bill and Closed ops only show under their own Billing Status filter, so they aren't counted.
  const rows = document.querySelectorAll('#jobList .job-item:not(.complete-job):not(.closed-job)');
  const currentUserFirst = (localStorage.getItem('currentUserName') || '').split(' ')[0];
  let mine = 0, unscheduled = 0, blocked = 0, thisWeek = 0;
  rows.forEach(row => {
    let data;
    try { data = JSON.parse(row.getAttribute('data-jobInfo') || '{}'); } catch (_) { data = {}; }
    if (currentUserFirst && splitTechs(data.Techs).includes(currentUserFirst)) mine++;
    if (!data.Schedule_Date || !data.Techs) unscheduled++;
    if (data.Status === 'Hold' || data.Parts_Ordered === 'Part Ordered' || Number(data.Operation_Dependency) > 0) blocked++;
    if (isThisWeek(data.Schedule_Date)) thisWeek++;
  });
  const setCount = (id, n) => { const el = document.getElementById(id); if (el) el.textContent = `· ${n}`; };
  setCount('job-chip-count-all', rows.length);
  setCount('job-chip-count-mine', mine);
  setCount('job-chip-count-unscheduled', unscheduled);
  setCount('job-chip-count-blocked', blocked);
  setCount('job-chip-count-this-week', thisWeek);
}

document.addEventListener('DOMContentLoaded', () => {
  const jobChipBar = document.getElementById('job-quick-filters');
  if (!jobChipBar) return;

  jobChipBar.querySelectorAll('[data-job-chip]').forEach(chip => {
    chip.addEventListener('click', () => {
      jobChipBar.querySelectorAll('[data-job-chip]').forEach(c => c.classList.toggle('active', c === chip));
      applyJobQuickFilter(chip.getAttribute('data-job-chip'));
    });
  });
});

// No-match state (Shared Patterns §C): when the Work Order or Operations list has rows but
// search, a chip or the Filter panel hides every one, say what's filtering and offer Clear
// (or, with a search on top of filters, the same search without the filters).
function activeListFilters(searchId) {
  const out = [];
  const q = document.getElementById(searchId)?.value.trim();
  if (q) out.push(`search “${q}”`);
  if (billingWorkOrdersActive || billingJobsActive) out.push('Ready to Bill');
  if (closedWorkOrdersActive || closedJobsActive) out.push('Closed');
  document.querySelectorAll('#filter-view input[type="checkbox"]:checked, #filter-view input[type="radio"]:checked').forEach(i => {
    if (!i.value) return;
    out.push((i.closest('label')?.textContent || i.value).trim().replace(/\s+/g, ' '));
  });
  const from = document.getElementById('start-date')?.value;
  const to = document.getElementById('end-date')?.value;
  if (from || to) out.push(`dates ${from || '…'} – ${to || '…'}`);
  if (searchId === 'job-search') {
    const chip = document.querySelector('#job-quick-filters [data-job-chip].active');
    if (chip && chip.dataset.jobChip !== 'all') out.push(chip.firstChild.textContent.trim());
  }
  return [...new Set(out)];
}

async function clearListFilters(searchId, keepSearch) {
  if (searchId === 'job-search') {
    document.querySelectorAll('#job-quick-filters [data-job-chip]').forEach(c => c.classList.toggle('active', c.dataset.jobChip === 'all'));
    currentJobQuickFilter = 'all';
  } else {
    document.querySelectorAll('#wo-quick-filters [data-chip]').forEach(c => c.classList.toggle('active', c.dataset.chip === 'all'));
  }
  if (!keepSearch) document.getElementById(searchId).value = '';
  await clearFilters();
}

document.addEventListener('DOMContentLoaded', () => {
  const lists = [
    ['table-content', '.table-item', 'search', 'work-order-view', 'work orders'],
    ['jobList', '.job-item', 'job-search', 'job-view', 'operations'],
  ];
  lists.forEach(([listId, sel, searchId, viewId, what]) => {
    watchNoMatch(document.getElementById(listId), {
      itemSelector: sel,
      active: () => getComputedStyle(document.getElementById(viewId)).display !== 'none',
      describe: () => {
        const filters = activeListFilters(searchId);
        const q = document.getElementById(searchId)?.value.trim();
        return { what, filters, nearest: q && filters.length > 1 ? { label: `Search all for “${q}”` } : null };
      },
      onClear: () => clearListFilters(searchId, false),
      onNearest: () => clearListFilters(searchId, true),
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  setupFilterListeners();
  setupSortListeners();
  setupFilterAccordion();
  updateSortButtonLabel();
  updateFilterButtonBadge();

  const filterViewButton = document.getElementById('filter-view-button');

  filterViewButton.addEventListener('click', () => {
    document.getElementById('filter-view').classList.toggle('hideBox');
  });


  // #search already runs searchCall() on input; typing only hides/shows rows and never re-sorts.

  // Add event listeners for filter checkboxes
  const filterCheckboxes = document.querySelectorAll('#filter-view input[type="checkbox"]');
  filterCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateTable);
  });

  // Note: We don't need to add sort listeners here because setupSortListeners() already does this
});

export async function getJobDataIndex() {
  try {
    const db = await getDB();

    const tx = db.transaction("jobData", "readonly");
    const store = tx.objectStore("jobData");

    const data = await new Promise((resolve, reject) => {
      const req = store.getAll();

      req.onsuccess = () => resolve(req.result || []);
      req.onerror = () => reject(req.error);
    });

    return data;
  } catch (error) {
    console.error('getJobDataIndex error:', error);
    throw error;
  }
}
